// Prueft, ob die Wert-Zuordnungen einer Gambio-Option zum gewaehlten Vario-Attribut passen.
// Pur und ohne DOM, damit die Regel testbar bleibt.

export interface ValueMapping {
  gambioOptionId: string;
  gambioOptionValueId: string;
  varioAttributeId: string;
}

/**
 * Welche Wert-Zuordnungen der Option gehoeren NICHT zum Ziel-Attribut?
 *
 * Warum das zaehlt (Vorfall 2026-07-29): Beim Auflösen einer Attribut-Kollision wurde eine Option
 * auf ein anderes Attribut gestellt, ihre Wert-Zuordnungen blieben aber am alten. Danach widersprachen
 * sich Attribut- und Wert-Ebene — und genau daraus entsteht das Schema, dessen Wertemenge nicht zum
 * Attribut gehoert, worauf Vario STILL null Varianten-Kinder anlegt. Formal war die Kollision weg,
 * inhaltlich war der Zustand schlechter als vorher.
 *
 * `targetAttributeId === null` heisst „ein neu anzulegendes Attribut": das hat noch keine Werte, also
 * passt keine bestehende Zuordnung.
 */
export function staleValueMappings(
  valueMap: readonly ValueMapping[],
  gambioOptionId: string,
  targetAttributeId: string | null,
): ValueMapping[] {
  return valueMap.filter(
    (v) => v.gambioOptionId === gambioOptionId
      && (targetAttributeId === null || v.varioAttributeId !== targetAttributeId),
  );
}
